import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    categories: [],
    is_submit_disable: false,
    loading: false
  },
  mutations: {
    INIT_CATEGORY_MNGT_DIALOG(state) {
      state.visibility = true
    },
    SET_CATEGORY_MNGT_DIALOG_CATEGORIES(state, payload) {
      state.categories = payload
    },
    RESET_CATEGORY_MNGT_DIALOG(state) {
      state.visibility = false
    },
    SET_CATEGORY_MNGT_DIALOG_IS_SUBMIT_DISABLE(state, payload) {
      state.is_submit_disable = payload
    },
    SET_CATEGORY_MNGT_DIALOG_LOADING(state, payload) {
      state.loading = payload
    }
  },
  actions: {
    async fetchCategoryList({ commit }) {
      try {
        commit('SET_CATEGORY_MNGT_DIALOG_CATEGORIES', [])
        commit('SET_CATEGORY_MNGT_DIALOG_LOADING', true)
        const response = await api.getCategoryList()
        if (response.data.success) {
          let category_list = [{ id: null, name: 'All Categories' }]
          category_list = category_list.concat(response.data.data)
          commit('SET_CATEGORY_MNGT_DIALOG_CATEGORIES', category_list)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_CATEGORY_MNGT_DIALOG_LOADING', false)
      }
    },
    async addCategory({ rootState, commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.adding', Vuetify.locale.t('$vuetify.__General.category')), loading: true })
        commit('SET_CATEGORY_MNGT_DIALOG_IS_SUBMIT_DISABLE', true)

        const device_id = rootState.auth.selected_device
        const response = await api.addCategory({ params: { ...payload, device_id } })
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.add', Vuetify.locale.t('$vuetify.__General.category')),
            icon: 'check',
            timeout: '2000'
          })
          dispatch('fetchCategoryList')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_CATEGORY_MNGT_DIALOG_IS_SUBMIT_DISABLE', false)
      }
    },
    async updateCategory({ commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.updating', Vuetify.locale.t('$vuetify.__General.category')),
          loading: true
        })
        commit('SET_CATEGORY_MNGT_DIALOG_IS_SUBMIT_DISABLE', true)

        const response = await api.updateCategory({ params: payload })
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.update', Vuetify.locale.t('$vuetify.__General.category')),
            icon: 'check',
            timeout: '2000'
          })
          dispatch('fetchCategoryList')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_CATEGORY_MNGT_DIALOG_IS_SUBMIT_DISABLE', false)
      }
    }
  }
}
